import { render, staticRenderFns } from "./MesaObrasVisadoParcelarioPaseNewOrEdit.vue?vue&type=template&id=2ce9922a&scoped=true&"
import script from "./MesaObrasVisadoParcelarioPaseNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./MesaObrasVisadoParcelarioPaseNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./MesaObrasVisadoParcelarioPaseNewOrEdit.vue?vue&type=style&index=0&id=2ce9922a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce9922a",
  null
  
)

export default component.exports